import { CardDataType, type CardData, ComponentName } from "../types";

export class PlusCardData implements CardData {

    constructor(
        private readonly itemClass: string,
        private readonly caption: string,
    ) { }

    getId(): string {
        return "plus";
    }

    getClass(): string {
        return this.itemClass;
    }

    getType(): CardDataType {
        return CardDataType.Plus;
    }

    getComponentName(): ComponentName {
        return ComponentName.PLUS;
    }

    getCaption(): string {
        return this.caption;
    }
}
